import {default as axios} from 'axios'

let {API_ENDPOINT} = process.env

const request = (method, path, data = {}) => {
  if(!sessionStorage.access_token) {
    throw new Error('ActionStation API requires an access token')
  }

  return axios({
    method, url: `${API_ENDPOINT}${path}`,
    data, headers: {'Authorization': `Bearer ${sessionStorage.access_token}`}
  })
}

export const api = {
  get: path => request('get', path),
  patch: (path, data) => request('patch', path, data),
  post: (path, data) => request('post', path, data),
  delete: (path, data) => request('delete', path, data)
}
